import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const CalendarsSettings = () => {
  return (
    <SettingsCard title="Calendarios">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default CalendarsSettings;